import React from 'react';
import { ToastContainer } from 'react-toastify';
import GlobalPageEvents from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/GlobalPageEvents';

export default function GlobalPageComponents() {
    return (
        <>
            <GlobalPageEvents />
            <ToastContainer
                autoClose={5000}
                theme="colored"
            />
        </>
    );
}
